import {
  DocumentRAGSettings,
  MyFile,
} from '@/redux/types/configuration'

export interface ApiDocumentSetting {
  id?: number
  document_id: number
  use_full_context?: boolean
  rag_enabled?: boolean | null
  rag_top_k?: number | null
  rag_chunk_size?: number | null
  rag_chunk_overlap?: number | null
  rag_similarity_threshold?: number | null
  rag_max_context_length?: number | null
}

export function buildDocumentSettingsMap(
  documentSettings: ApiDocumentSetting[] | null | undefined
): Record<number, DocumentRAGSettings> {
  const map: Record<number, DocumentRAGSettings> = {}
  if (!documentSettings) {
    return map
  }

  documentSettings.forEach((setting) => {
    if (!setting.document_id) {
      return
    }
    map[setting.document_id] = {
      use_full_context: setting.use_full_context || false,
      rag_enabled: setting.rag_enabled,
      rag_top_k: setting.rag_top_k,
      rag_chunk_size: setting.rag_chunk_size,
      rag_chunk_overlap: setting.rag_chunk_overlap,
      rag_similarity_threshold: setting.rag_similarity_threshold,
      rag_max_context_length: setting.rag_max_context_length,
    }
  })

  return map
}

export function attachDocumentSettingsToFiles(
  files: MyFile[],
  documentSettings: ApiDocumentSetting[] | null | undefined
): MyFile[] {
  const documentSettingsMap = buildDocumentSettingsMap(documentSettings)
  return files.map((file) => ({
    ...file,
    rag_settings: documentSettingsMap[file.id],
  }))
}
